import {useEffect,useLayoutEffect,useRef,useState} from 'react';
import {normalizePinyin} from './pinyin';
import '../styles/pinyin.css';

const usePresentationEffect=typeof window==='undefined'?useEffect:useLayoutEffect;

/** One continuous NFC run. Fit is opt-in for compact pronunciation cards. */
export function PinyinText({text,fit=false,className=''}:{text:string;fit?:boolean;className?:string}){
 const node=useRef<HTMLSpanElement>(null),[size,setSize]=useState<number>();
 usePresentationEffect(()=>{
  const element=node.current;
  if(!fit||!element)return;
  const parent=element.parentElement;if(!parent)return;
  let active=true;
  const measure=()=>{
   if(!active)return;
   element.style.fontSize='';
   const natural=parseFloat(getComputedStyle(element).fontSize),available=parent.clientWidth;
   const width=element.getBoundingClientRect().width;
   const next=width>available&&available>0?Math.max(14,Math.floor(natural*available/width)):undefined;
   element.style.fontSize=next?`${next}px`:'';setSize(next);
  };
  const observer=new ResizeObserver(measure);observer.observe(parent);measure();
  void document.fonts.ready.then(measure);
  return()=>{active=false;observer.disconnect();};
 },[text,fit]);
 return <span ref={node} lang="zh-Latn" className={`pinyin-text pinyin-run${fit?' pinyin-fit':''}${className?' '+className:''}`} style={size?{fontSize:size}:undefined}>{normalizePinyin(text)}</span>;
}
/** Mixed authored prose retains Russian/Chinese fonts; Latin runs share one font. */
export function PinyinInline({text}:{text:string}){
 const parts=normalizePinyin(text).split(/([\p{Script=Latin}\p{Mark}]+(?:[’'][\p{Script=Latin}\p{Mark}]+)*)/u);
 return <>{parts.map((part,index)=>/^[\p{Script=Latin}\p{Mark}’']+$/u.test(part)?<PinyinText key={index} text={part}/>:part)}</>;
}
